import React, { useEffect, useMemo, useState } from "react";
import EdicionClientePredeterminado from "./edicion/EdicionClientePredeterminado";
import AltaClientePredeterminado from "./alta/AltaClientePredeterminado";
import Navbar from "../../Navbar";
import MaterialReactTable from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import {
  Button,
  Typography,
  Container,
  Tooltip,
  IconButton,
} from "@mui/material";
import { getData } from "../../../services/library";
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import DescriptionIcon from "@mui/icons-material/Description";
import EditIcon from "@mui/icons-material/Edit";

function PredeterminadosSisven() {
  const [clientesPredeterminados, setClientesPredeterminados] = useState(); //aca se almacenan los datos que me trae la api
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [tabla, setTabla] = useState(true); //Estado q mostrará o no la tabla (pantalla inicial) dnd estan los clientes
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [dataCliente, setDataCliente] = useState({});

  //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
  const obtenerClientesPredeterminados = () => {
    getData("/envasado_sisven_predeterminados/", setClientesPredeterminados);
  };

  useEffect(() => {
    obtenerClientesPredeterminados();
  }, [tabla]);

  const handleClickNuevo = () => {
    setAlta(true);
  };

  const handleCloseEditar = () => {
    setEditar(false);
    setTabla(true);
    obtenerClientesPredeterminados();
  };
  const handleCloseAlta = () => {
    setAlta(false);
    setTabla(true);
    obtenerClientesPredeterminados();
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "nombre_sucursal", //access nested data with dot notation
        header: "Sucursal",
      },
      {
        accessorKey: "sisven_id",
        header: "Cliente Sisven", //access nested data with dot notation
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 1 }}>
        {tabla && (
          <MaterialReactTable
            localization={MRT_Localization_ES}
            columns={columns}
            data={clientesPredeterminados ?? [{}]}
            layoutMode={"grid"}
            initialState={initialState}
            enableColumnActions={false} //deshabilita las acciones POR COLUMNA
            enableGlobalFilterModes={false}
            enableHiding={false}
            enableRowActions={true}
            enableColumnFilters={false}
            enableFullScreenToggle={false}
            positionActionsColumn={"last"}
            enableExpandAll={false}
            enableToolbarInternalActions={true}
            muiTableHeadCellProps={tableHeadCellProps}
            muiSearchTextFieldProps={muiSearchTextFieldProps}
            enableDensityToggle={false}
            displayColumnDefOptions={displayColumnDefOptions}
            enableColumnResizing={true}
            muiTableBodyCellProps={({ row }) => ({
              align: "left",
              sx: {
                color: "black",
              },
            })}
            renderTopToolbarCustomActions={() => (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddBoxTwoToneIcon color="asd" />}
                  onClick={handleClickNuevo}
                >
                  Nuevo Cliente Predeterminado
                </Button>
                <Typography variant="poster" fontSize={26}>
                  <DescriptionIcon sx={{ fontSize: 20 }} />
                  Clientes Predeterminados Sisven
                </Typography>
              </>
            )}
            renderRowActions={({ row }) => (
              <Tooltip arrow placement="right" title="Editar">
                <IconButton
                  onClick={() => {
                    setDataCliente(row.original);
                    setEditar(true);
                  }}
                  color="primary"
                >
                  <EditIcon />
                </IconButton>
              </Tooltip>
            )}
          />
        )}

        {editar ? (
          <EdicionClientePredeterminado
            editar={editar}
            datosRow={dataCliente}
            onClose={() => handleCloseEditar(false)}
          />
        ) : null}
        {alta ? (
          <AltaClientePredeterminado
            alta={alta}
            onClose={() => handleCloseAlta(false)}
            clientesPredeterminados={clientesPredeterminados}
          />
        ) : null}
      </Container>
    </>
  );
}

export default PredeterminadosSisven;
